import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @param props.children
 * @returns {JSX.Element} Component.
 */
export const StatsSectionSearchMobile = ({ children }) => {
    return (
        <>
            {React.Children.map(children, (child) => (
                <>{child}</>
            ))}
        </>
    );
};

StatsSectionSearchMobile.defaultProps = {
    name: 'StatsSectionSearchMobile'
};

StatsSectionSearchMobile.propTypes = {
    children: PropTypes.any.isRequired
};
